import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Row, Col, Button, Input } from 'antd'

import './index.css'

import Logo from 'assets/images/ekko-logo.png'

import { prevStep, validatePlugin } from 'redux/OnBoardingNow/actions'

const RowInputCopy = ({ title, data }) => {
    return (
        <Row align="middle" type="flex" style={{ marginBottom: 12 }}>
            <Col xs={24} sm={9}>
                <h2 style={{ margin: 0 }}>{title} :</h2>
            </Col>
            <Col xs={24} sm={13}>
                <Input value={data}></Input>
            </Col>
        </Row>
    )
}

class EndWordPress extends React.Component {
    onPrev = () => {
        const { back } = this.props

        back()
    }

    onNext = () => {
        const { done } = this.props

        done()
    }

    render() {
        const { applicationId } = this.props

        return (
            <Col xs={22} sm={22} md={18}>
                <img src={Logo} height="42" />
                <h2 style={{ paddingTop: 50 }} className="tuto-step">
                    1) Install the Wordpress plugin available{' '}
                    <a href="https://s3.amazonaws.com/static.ekko.chat/plugin/plugin-wordperss-ekko-now.zip">here</a>
                </h2>
                <h2 className="tuto-step">2) Go in plugin configuration and set:</h2>
                <div style={{ marginLeft: 30, marginBottom: 30 }}>
                    <RowInputCopy title="Application ID" data={applicationId} />
                </div>
                <h2 className="tuto-step">3) Save and restart your Wordpress.</h2>

                <div style={{ paddingTop: 40 }}>
                    <Row justify="space-between" type="flex">
                        <Button onClick={this.onPrev}>Prev</Button>
                        <Button type="primary" onClick={this.onNext}>
                            Done
                        </Button>
                        <div />
                    </Row>
                </div>
            </Col>
        )
    }
}

const mapStateToProps = ({ onboarding, ekko }) => ({
    applicationId: ekko.currentAppId
})

const mapActionsToProps = dispatch => ({
    back: bindActionCreators(prevStep, dispatch),
    done: bindActionCreators(validatePlugin, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(EndWordPress)
